var React = require('react');

function ArrowDownDouble (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"}));
}

ArrowDownDouble.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"fas","data-icon":"angle-double-down","className":"svg-inline--fa fa-angle-double-down fa-w-10","role":"img","viewBox":"0 0 320 512"};

module.exports = ArrowDownDouble;

ArrowDownDouble.default = ArrowDownDouble;
